/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as ScreeningImport } from './routes/screening';
import { Route as PatientsImport } from './routes/patients';
import { Route as AppointmentsImport } from './routes/appointments';
import { Route as IndexImport } from './routes/index';
import { Route as TodosIndexImport } from './routes/todos/index';
import { Route as ScreeningIndexImport } from './routes/screening/index';
import { Route as PatientsIndexImport } from './routes/patients/index';
import { Route as MasterdataIndexImport } from './routes/masterdata/index';
import { Route as HistoryIndexImport } from './routes/history/index';
import { Route as ContactTracingIndexImport } from './routes/contact-tracing/index';
import { Route as AppointmentsIndexImport } from './routes/appointments/index';
import { Route as ScreeningScreeningIdImport } from './routes/screening/$screeningId';
import { Route as PatientsPatientIdImport } from './routes/patients/$patientId';
import { Route as ContactTracingPatientIdImport } from './routes/contact-tracing/$patientId';
import { Route as ScreeningScreeningIdIndexImport } from './routes/screening/$screeningId/index';
import { Route as ReviewFileIdIndexImport } from './routes/review/$fileId/index';
import { Route as PatientsPatientIdIndexImport } from './routes/patients/$patientId/index';
import { Route as ContactTracingPatientIdIndexImport } from './routes/contact-tracing/$patientId/index';
import { Route as AppointmentsAppointmentIdIndexImport } from './routes/appointments/$appointmentId/index';
import { Route as ScreeningScreeningIdIndividualsImport } from './routes/screening/$screeningId/individuals';
import { Route as PatientsPatientIdTherapyImport } from './routes/patients/$patientId/therapy';
import { Route as PatientsPatientIdNetworkImport } from './routes/patients/$patientId/network';
import { Route as PatientsPatientIdHistoryImport } from './routes/patients/$patientId/history';
import { Route as PatientsPatientIdDocumentImport } from './routes/patients/$patientId/document';
import { Route as PatientsPatientIdDiagnosticsImport } from './routes/patients/$patientId/diagnostics';
import { Route as PatientsPatientIdAnamnesisImport } from './routes/patients/$patientId/anamnesis';
import { Route as MasterdataPersonsPersonIdImport } from './routes/masterdata/persons/$personId';
import { Route as ContactTracingPatientIdDocumentImport } from './routes/contact-tracing/$patientId/document';
import { Route as ScreeningScreeningIdIndividualsIndexImport } from './routes/screening/$screeningId/individuals/index';
import { Route as MasterdataPersonsPersonIdIndexImport } from './routes/masterdata/persons/$personId/index';
import { Route as ScreeningScreeningIdIndividualsIndividualIdImport } from './routes/screening/$screeningId/individuals/$individualId';
import { Route as MasterdataPersonsPersonIdHistoryImport } from './routes/masterdata/persons/$personId/history';
import { Route as MasterdataPersonsPersonIdDocumentImport } from './routes/masterdata/persons/$personId/document';
import { Route as ScreeningScreeningIdIndividualsIndividualIdIndexImport } from './routes/screening/$screeningId/individuals/$individualId/index';
import { Route as ScreeningScreeningIdIndividualsIndividualIdDocumentImport } from './routes/screening/$screeningId/individuals/$individualId/document';

// Create/Update Routes

const ScreeningRoute = ScreeningImport.update({
  id: '/screening',
  path: '/screening',
  getParentRoute: () => rootRoute,
} as any);

const PatientsRoute = PatientsImport.update({
  id: '/patients',
  path: '/patients',
  getParentRoute: () => rootRoute,
} as any);

const AppointmentsRoute = AppointmentsImport.update({
  id: '/appointments',
  path: '/appointments',
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any);

const TodosIndexRoute = TodosIndexImport.update({
  id: '/todos/',
  path: '/todos/',
  getParentRoute: () => rootRoute,
} as any);

const ScreeningIndexRoute = ScreeningIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ScreeningRoute,
} as any);

const PatientsIndexRoute = PatientsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PatientsRoute,
} as any);

const MasterdataIndexRoute = MasterdataIndexImport.update({
  id: '/masterdata/',
  path: '/masterdata/',
  getParentRoute: () => rootRoute,
} as any);

const HistoryIndexRoute = HistoryIndexImport.update({
  id: '/history/',
  path: '/history/',
  getParentRoute: () => rootRoute,
} as any);

const ContactTracingIndexRoute = ContactTracingIndexImport.update({
  id: '/contact-tracing/',
  path: '/contact-tracing/',
  getParentRoute: () => rootRoute,
} as any);

const AppointmentsIndexRoute = AppointmentsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppointmentsRoute,
} as any);

const ScreeningScreeningIdRoute = ScreeningScreeningIdImport.update({
  id: '/$screeningId',
  path: '/$screeningId',
  getParentRoute: () => ScreeningRoute,
} as any);

const PatientsPatientIdRoute = PatientsPatientIdImport.update({
  id: '/$patientId',
  path: '/$patientId',
  getParentRoute: () => PatientsRoute,
} as any);

const ContactTracingPatientIdRoute = ContactTracingPatientIdImport.update({
  id: '/contact-tracing/$patientId',
  path: '/contact-tracing/$patientId',
  getParentRoute: () => rootRoute,
} as any);

const ScreeningScreeningIdIndexRoute = ScreeningScreeningIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ScreeningScreeningIdRoute,
} as any);

const ReviewFileIdIndexRoute = ReviewFileIdIndexImport.update({
  id: '/review/$fileId/',
  path: '/review/$fileId/',
  getParentRoute: () => rootRoute,
} as any);

const PatientsPatientIdIndexRoute = PatientsPatientIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PatientsPatientIdRoute,
} as any);

const ContactTracingPatientIdIndexRoute =
  ContactTracingPatientIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ContactTracingPatientIdRoute,
  } as any);

const AppointmentsAppointmentIdIndexRoute =
  AppointmentsAppointmentIdIndexImport.update({
    id: '/$appointmentId/',
    path: '/$appointmentId/',
    getParentRoute: () => AppointmentsRoute,
  } as any);

const ScreeningScreeningIdIndividualsRoute =
  ScreeningScreeningIdIndividualsImport.update({
    id: '/individuals',
    path: '/individuals',
    getParentRoute: () => ScreeningScreeningIdRoute,
  } as any);

const PatientsPatientIdTherapyRoute = PatientsPatientIdTherapyImport.update({
  id: '/therapy',
  path: '/therapy',
  getParentRoute: () => PatientsPatientIdRoute,
} as any);

const PatientsPatientIdNetworkRoute = PatientsPatientIdNetworkImport.update({
  id: '/network',
  path: '/network',
  getParentRoute: () => PatientsPatientIdRoute,
} as any);

const PatientsPatientIdHistoryRoute = PatientsPatientIdHistoryImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => PatientsPatientIdRoute,
} as any);

const PatientsPatientIdDocumentRoute = PatientsPatientIdDocumentImport.update({
  id: '/document',
  path: '/document',
  getParentRoute: () => PatientsPatientIdRoute,
} as any);

const PatientsPatientIdDiagnosticsRoute =
  PatientsPatientIdDiagnosticsImport.update({
    id: '/diagnostics',
    path: '/diagnostics',
    getParentRoute: () => PatientsPatientIdRoute,
  } as any);

const PatientsPatientIdAnamnesisRoute = PatientsPatientIdAnamnesisImport.update(
  {
    id: '/anamnesis',
    path: '/anamnesis',
    getParentRoute: () => PatientsPatientIdRoute,
  } as any,
);

const MasterdataPersonsPersonIdRoute = MasterdataPersonsPersonIdImport.update({
  id: '/masterdata/persons/$personId',
  path: '/masterdata/persons/$personId',
  getParentRoute: () => rootRoute,
} as any);

const ContactTracingPatientIdDocumentRoute =
  ContactTracingPatientIdDocumentImport.update({
    id: '/document',
    path: '/document',
    getParentRoute: () => ContactTracingPatientIdRoute,
  } as any);

const ScreeningScreeningIdIndividualsIndexRoute =
  ScreeningScreeningIdIndividualsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ScreeningScreeningIdIndividualsRoute,
  } as any);

const MasterdataPersonsPersonIdIndexRoute =
  MasterdataPersonsPersonIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MasterdataPersonsPersonIdRoute,
  } as any);

const ScreeningScreeningIdIndividualsIndividualIdRoute =
  ScreeningScreeningIdIndividualsIndividualIdImport.update({
    id: '/$individualId',
    path: '/$individualId',
    getParentRoute: () => ScreeningScreeningIdIndividualsRoute,
  } as any);

const MasterdataPersonsPersonIdHistoryRoute =
  MasterdataPersonsPersonIdHistoryImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => MasterdataPersonsPersonIdRoute,
  } as any);

const MasterdataPersonsPersonIdDocumentRoute =
  MasterdataPersonsPersonIdDocumentImport.update({
    id: '/document',
    path: '/document',
    getParentRoute: () => MasterdataPersonsPersonIdRoute,
  } as any);

const ScreeningScreeningIdIndividualsIndividualIdIndexRoute =
  ScreeningScreeningIdIndividualsIndividualIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ScreeningScreeningIdIndividualsIndividualIdRoute,
  } as any);

const ScreeningScreeningIdIndividualsIndividualIdDocumentRoute =
  ScreeningScreeningIdIndividualsIndividualIdDocumentImport.update({
    id: '/document',
    path: '/document',
    getParentRoute: () => ScreeningScreeningIdIndividualsIndividualIdRoute,
  } as any);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/appointments': {
      id: '/appointments';
      path: '/appointments';
      fullPath: '/appointments';
      preLoaderRoute: typeof AppointmentsImport;
      parentRoute: typeof rootRoute;
    };
    '/patients': {
      id: '/patients';
      path: '/patients';
      fullPath: '/patients';
      preLoaderRoute: typeof PatientsImport;
      parentRoute: typeof rootRoute;
    };
    '/screening': {
      id: '/screening';
      path: '/screening';
      fullPath: '/screening';
      preLoaderRoute: typeof ScreeningImport;
      parentRoute: typeof rootRoute;
    };
    '/contact-tracing/$patientId': {
      id: '/contact-tracing/$patientId';
      path: '/contact-tracing/$patientId';
      fullPath: '/contact-tracing/$patientId';
      preLoaderRoute: typeof ContactTracingPatientIdImport;
      parentRoute: typeof rootRoute;
    };
    '/patients/$patientId': {
      id: '/patients/$patientId';
      path: '/$patientId';
      fullPath: '/patients/$patientId';
      preLoaderRoute: typeof PatientsPatientIdImport;
      parentRoute: typeof PatientsImport;
    };
    '/screening/$screeningId': {
      id: '/screening/$screeningId';
      path: '/$screeningId';
      fullPath: '/screening/$screeningId';
      preLoaderRoute: typeof ScreeningScreeningIdImport;
      parentRoute: typeof ScreeningImport;
    };
    '/appointments/': {
      id: '/appointments/';
      path: '/';
      fullPath: '/appointments/';
      preLoaderRoute: typeof AppointmentsIndexImport;
      parentRoute: typeof AppointmentsImport;
    };
    '/contact-tracing/': {
      id: '/contact-tracing/';
      path: '/contact-tracing';
      fullPath: '/contact-tracing';
      preLoaderRoute: typeof ContactTracingIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/history/': {
      id: '/history/';
      path: '/history';
      fullPath: '/history';
      preLoaderRoute: typeof HistoryIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/masterdata/': {
      id: '/masterdata/';
      path: '/masterdata';
      fullPath: '/masterdata';
      preLoaderRoute: typeof MasterdataIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/patients/': {
      id: '/patients/';
      path: '/';
      fullPath: '/patients/';
      preLoaderRoute: typeof PatientsIndexImport;
      parentRoute: typeof PatientsImport;
    };
    '/screening/': {
      id: '/screening/';
      path: '/';
      fullPath: '/screening/';
      preLoaderRoute: typeof ScreeningIndexImport;
      parentRoute: typeof ScreeningImport;
    };
    '/todos/': {
      id: '/todos/';
      path: '/todos';
      fullPath: '/todos';
      preLoaderRoute: typeof TodosIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/contact-tracing/$patientId/document': {
      id: '/contact-tracing/$patientId/document';
      path: '/document';
      fullPath: '/contact-tracing/$patientId/document';
      preLoaderRoute: typeof ContactTracingPatientIdDocumentImport;
      parentRoute: typeof ContactTracingPatientIdImport;
    };
    '/masterdata/persons/$personId': {
      id: '/masterdata/persons/$personId';
      path: '/masterdata/persons/$personId';
      fullPath: '/masterdata/persons/$personId';
      preLoaderRoute: typeof MasterdataPersonsPersonIdImport;
      parentRoute: typeof rootRoute;
    };
    '/patients/$patientId/anamnesis': {
      id: '/patients/$patientId/anamnesis';
      path: '/anamnesis';
      fullPath: '/patients/$patientId/anamnesis';
      preLoaderRoute: typeof PatientsPatientIdAnamnesisImport;
      parentRoute: typeof PatientsPatientIdImport;
    };
    '/patients/$patientId/diagnostics': {
      id: '/patients/$patientId/diagnostics';
      path: '/diagnostics';
      fullPath: '/patients/$patientId/diagnostics';
      preLoaderRoute: typeof PatientsPatientIdDiagnosticsImport;
      parentRoute: typeof PatientsPatientIdImport;
    };
    '/patients/$patientId/document': {
      id: '/patients/$patientId/document';
      path: '/document';
      fullPath: '/patients/$patientId/document';
      preLoaderRoute: typeof PatientsPatientIdDocumentImport;
      parentRoute: typeof PatientsPatientIdImport;
    };
    '/patients/$patientId/history': {
      id: '/patients/$patientId/history';
      path: '/history';
      fullPath: '/patients/$patientId/history';
      preLoaderRoute: typeof PatientsPatientIdHistoryImport;
      parentRoute: typeof PatientsPatientIdImport;
    };
    '/patients/$patientId/network': {
      id: '/patients/$patientId/network';
      path: '/network';
      fullPath: '/patients/$patientId/network';
      preLoaderRoute: typeof PatientsPatientIdNetworkImport;
      parentRoute: typeof PatientsPatientIdImport;
    };
    '/patients/$patientId/therapy': {
      id: '/patients/$patientId/therapy';
      path: '/therapy';
      fullPath: '/patients/$patientId/therapy';
      preLoaderRoute: typeof PatientsPatientIdTherapyImport;
      parentRoute: typeof PatientsPatientIdImport;
    };
    '/screening/$screeningId/individuals': {
      id: '/screening/$screeningId/individuals';
      path: '/individuals';
      fullPath: '/screening/$screeningId/individuals';
      preLoaderRoute: typeof ScreeningScreeningIdIndividualsImport;
      parentRoute: typeof ScreeningScreeningIdImport;
    };
    '/appointments/$appointmentId/': {
      id: '/appointments/$appointmentId/';
      path: '/$appointmentId';
      fullPath: '/appointments/$appointmentId';
      preLoaderRoute: typeof AppointmentsAppointmentIdIndexImport;
      parentRoute: typeof AppointmentsImport;
    };
    '/contact-tracing/$patientId/': {
      id: '/contact-tracing/$patientId/';
      path: '/';
      fullPath: '/contact-tracing/$patientId/';
      preLoaderRoute: typeof ContactTracingPatientIdIndexImport;
      parentRoute: typeof ContactTracingPatientIdImport;
    };
    '/patients/$patientId/': {
      id: '/patients/$patientId/';
      path: '/';
      fullPath: '/patients/$patientId/';
      preLoaderRoute: typeof PatientsPatientIdIndexImport;
      parentRoute: typeof PatientsPatientIdImport;
    };
    '/review/$fileId/': {
      id: '/review/$fileId/';
      path: '/review/$fileId';
      fullPath: '/review/$fileId';
      preLoaderRoute: typeof ReviewFileIdIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/screening/$screeningId/': {
      id: '/screening/$screeningId/';
      path: '/';
      fullPath: '/screening/$screeningId/';
      preLoaderRoute: typeof ScreeningScreeningIdIndexImport;
      parentRoute: typeof ScreeningScreeningIdImport;
    };
    '/masterdata/persons/$personId/document': {
      id: '/masterdata/persons/$personId/document';
      path: '/document';
      fullPath: '/masterdata/persons/$personId/document';
      preLoaderRoute: typeof MasterdataPersonsPersonIdDocumentImport;
      parentRoute: typeof MasterdataPersonsPersonIdImport;
    };
    '/masterdata/persons/$personId/history': {
      id: '/masterdata/persons/$personId/history';
      path: '/history';
      fullPath: '/masterdata/persons/$personId/history';
      preLoaderRoute: typeof MasterdataPersonsPersonIdHistoryImport;
      parentRoute: typeof MasterdataPersonsPersonIdImport;
    };
    '/screening/$screeningId/individuals/$individualId': {
      id: '/screening/$screeningId/individuals/$individualId';
      path: '/$individualId';
      fullPath: '/screening/$screeningId/individuals/$individualId';
      preLoaderRoute: typeof ScreeningScreeningIdIndividualsIndividualIdImport;
      parentRoute: typeof ScreeningScreeningIdIndividualsImport;
    };
    '/masterdata/persons/$personId/': {
      id: '/masterdata/persons/$personId/';
      path: '/';
      fullPath: '/masterdata/persons/$personId/';
      preLoaderRoute: typeof MasterdataPersonsPersonIdIndexImport;
      parentRoute: typeof MasterdataPersonsPersonIdImport;
    };
    '/screening/$screeningId/individuals/': {
      id: '/screening/$screeningId/individuals/';
      path: '/';
      fullPath: '/screening/$screeningId/individuals/';
      preLoaderRoute: typeof ScreeningScreeningIdIndividualsIndexImport;
      parentRoute: typeof ScreeningScreeningIdIndividualsImport;
    };
    '/screening/$screeningId/individuals/$individualId/document': {
      id: '/screening/$screeningId/individuals/$individualId/document';
      path: '/document';
      fullPath: '/screening/$screeningId/individuals/$individualId/document';
      preLoaderRoute: typeof ScreeningScreeningIdIndividualsIndividualIdDocumentImport;
      parentRoute: typeof ScreeningScreeningIdIndividualsIndividualIdImport;
    };
    '/screening/$screeningId/individuals/$individualId/': {
      id: '/screening/$screeningId/individuals/$individualId/';
      path: '/';
      fullPath: '/screening/$screeningId/individuals/$individualId/';
      preLoaderRoute: typeof ScreeningScreeningIdIndividualsIndividualIdIndexImport;
      parentRoute: typeof ScreeningScreeningIdIndividualsIndividualIdImport;
    };
  }
}

// Create and export the route tree

interface AppointmentsRouteChildren {
  AppointmentsIndexRoute: typeof AppointmentsIndexRoute;
  AppointmentsAppointmentIdIndexRoute: typeof AppointmentsAppointmentIdIndexRoute;
}

const AppointmentsRouteChildren: AppointmentsRouteChildren = {
  AppointmentsIndexRoute: AppointmentsIndexRoute,
  AppointmentsAppointmentIdIndexRoute: AppointmentsAppointmentIdIndexRoute,
};

const AppointmentsRouteWithChildren = AppointmentsRoute._addFileChildren(
  AppointmentsRouteChildren,
);

interface PatientsPatientIdRouteChildren {
  PatientsPatientIdAnamnesisRoute: typeof PatientsPatientIdAnamnesisRoute;
  PatientsPatientIdDiagnosticsRoute: typeof PatientsPatientIdDiagnosticsRoute;
  PatientsPatientIdDocumentRoute: typeof PatientsPatientIdDocumentRoute;
  PatientsPatientIdHistoryRoute: typeof PatientsPatientIdHistoryRoute;
  PatientsPatientIdNetworkRoute: typeof PatientsPatientIdNetworkRoute;
  PatientsPatientIdTherapyRoute: typeof PatientsPatientIdTherapyRoute;
  PatientsPatientIdIndexRoute: typeof PatientsPatientIdIndexRoute;
}

const PatientsPatientIdRouteChildren: PatientsPatientIdRouteChildren = {
  PatientsPatientIdAnamnesisRoute: PatientsPatientIdAnamnesisRoute,
  PatientsPatientIdDiagnosticsRoute: PatientsPatientIdDiagnosticsRoute,
  PatientsPatientIdDocumentRoute: PatientsPatientIdDocumentRoute,
  PatientsPatientIdHistoryRoute: PatientsPatientIdHistoryRoute,
  PatientsPatientIdNetworkRoute: PatientsPatientIdNetworkRoute,
  PatientsPatientIdTherapyRoute: PatientsPatientIdTherapyRoute,
  PatientsPatientIdIndexRoute: PatientsPatientIdIndexRoute,
};

const PatientsPatientIdRouteWithChildren =
  PatientsPatientIdRoute._addFileChildren(PatientsPatientIdRouteChildren);

interface PatientsRouteChildren {
  PatientsPatientIdRoute: typeof PatientsPatientIdRouteWithChildren;
  PatientsIndexRoute: typeof PatientsIndexRoute;
}

const PatientsRouteChildren: PatientsRouteChildren = {
  PatientsPatientIdRoute: PatientsPatientIdRouteWithChildren,
  PatientsIndexRoute: PatientsIndexRoute,
};

const PatientsRouteWithChildren = PatientsRoute._addFileChildren(
  PatientsRouteChildren,
);

interface ScreeningScreeningIdIndividualsIndividualIdRouteChildren {
  ScreeningScreeningIdIndividualsIndividualIdDocumentRoute: typeof ScreeningScreeningIdIndividualsIndividualIdDocumentRoute;
  ScreeningScreeningIdIndividualsIndividualIdIndexRoute: typeof ScreeningScreeningIdIndividualsIndividualIdIndexRoute;
}

const ScreeningScreeningIdIndividualsIndividualIdRouteChildren: ScreeningScreeningIdIndividualsIndividualIdRouteChildren =
  {
    ScreeningScreeningIdIndividualsIndividualIdDocumentRoute:
      ScreeningScreeningIdIndividualsIndividualIdDocumentRoute,
    ScreeningScreeningIdIndividualsIndividualIdIndexRoute:
      ScreeningScreeningIdIndividualsIndividualIdIndexRoute,
  };

const ScreeningScreeningIdIndividualsIndividualIdRouteWithChildren =
  ScreeningScreeningIdIndividualsIndividualIdRoute._addFileChildren(
    ScreeningScreeningIdIndividualsIndividualIdRouteChildren,
  );

interface ScreeningScreeningIdIndividualsRouteChildren {
  ScreeningScreeningIdIndividualsIndividualIdRoute: typeof ScreeningScreeningIdIndividualsIndividualIdRouteWithChildren;
  ScreeningScreeningIdIndividualsIndexRoute: typeof ScreeningScreeningIdIndividualsIndexRoute;
}

const ScreeningScreeningIdIndividualsRouteChildren: ScreeningScreeningIdIndividualsRouteChildren =
  {
    ScreeningScreeningIdIndividualsIndividualIdRoute:
      ScreeningScreeningIdIndividualsIndividualIdRouteWithChildren,
    ScreeningScreeningIdIndividualsIndexRoute:
      ScreeningScreeningIdIndividualsIndexRoute,
  };

const ScreeningScreeningIdIndividualsRouteWithChildren =
  ScreeningScreeningIdIndividualsRoute._addFileChildren(
    ScreeningScreeningIdIndividualsRouteChildren,
  );

interface ScreeningScreeningIdRouteChildren {
  ScreeningScreeningIdIndividualsRoute: typeof ScreeningScreeningIdIndividualsRouteWithChildren;
  ScreeningScreeningIdIndexRoute: typeof ScreeningScreeningIdIndexRoute;
}

const ScreeningScreeningIdRouteChildren: ScreeningScreeningIdRouteChildren = {
  ScreeningScreeningIdIndividualsRoute:
    ScreeningScreeningIdIndividualsRouteWithChildren,
  ScreeningScreeningIdIndexRoute: ScreeningScreeningIdIndexRoute,
};

const ScreeningScreeningIdRouteWithChildren =
  ScreeningScreeningIdRoute._addFileChildren(ScreeningScreeningIdRouteChildren);

interface ScreeningRouteChildren {
  ScreeningScreeningIdRoute: typeof ScreeningScreeningIdRouteWithChildren;
  ScreeningIndexRoute: typeof ScreeningIndexRoute;
}

const ScreeningRouteChildren: ScreeningRouteChildren = {
  ScreeningScreeningIdRoute: ScreeningScreeningIdRouteWithChildren,
  ScreeningIndexRoute: ScreeningIndexRoute,
};

const ScreeningRouteWithChildren = ScreeningRoute._addFileChildren(
  ScreeningRouteChildren,
);

interface ContactTracingPatientIdRouteChildren {
  ContactTracingPatientIdDocumentRoute: typeof ContactTracingPatientIdDocumentRoute;
  ContactTracingPatientIdIndexRoute: typeof ContactTracingPatientIdIndexRoute;
}

const ContactTracingPatientIdRouteChildren: ContactTracingPatientIdRouteChildren =
  {
    ContactTracingPatientIdDocumentRoute: ContactTracingPatientIdDocumentRoute,
    ContactTracingPatientIdIndexRoute: ContactTracingPatientIdIndexRoute,
  };

const ContactTracingPatientIdRouteWithChildren =
  ContactTracingPatientIdRoute._addFileChildren(
    ContactTracingPatientIdRouteChildren,
  );

interface MasterdataPersonsPersonIdRouteChildren {
  MasterdataPersonsPersonIdDocumentRoute: typeof MasterdataPersonsPersonIdDocumentRoute;
  MasterdataPersonsPersonIdHistoryRoute: typeof MasterdataPersonsPersonIdHistoryRoute;
  MasterdataPersonsPersonIdIndexRoute: typeof MasterdataPersonsPersonIdIndexRoute;
}

const MasterdataPersonsPersonIdRouteChildren: MasterdataPersonsPersonIdRouteChildren =
  {
    MasterdataPersonsPersonIdDocumentRoute:
      MasterdataPersonsPersonIdDocumentRoute,
    MasterdataPersonsPersonIdHistoryRoute:
      MasterdataPersonsPersonIdHistoryRoute,
    MasterdataPersonsPersonIdIndexRoute: MasterdataPersonsPersonIdIndexRoute,
  };

const MasterdataPersonsPersonIdRouteWithChildren =
  MasterdataPersonsPersonIdRoute._addFileChildren(
    MasterdataPersonsPersonIdRouteChildren,
  );

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/appointments': typeof AppointmentsRouteWithChildren;
  '/patients': typeof PatientsRouteWithChildren;
  '/screening': typeof ScreeningRouteWithChildren;
  '/contact-tracing/$patientId': typeof ContactTracingPatientIdRouteWithChildren;
  '/patients/$patientId': typeof PatientsPatientIdRouteWithChildren;
  '/screening/$screeningId': typeof ScreeningScreeningIdRouteWithChildren;
  '/appointments/': typeof AppointmentsIndexRoute;
  '/contact-tracing': typeof ContactTracingIndexRoute;
  '/history': typeof HistoryIndexRoute;
  '/masterdata': typeof MasterdataIndexRoute;
  '/patients/': typeof PatientsIndexRoute;
  '/screening/': typeof ScreeningIndexRoute;
  '/todos': typeof TodosIndexRoute;
  '/contact-tracing/$patientId/document': typeof ContactTracingPatientIdDocumentRoute;
  '/masterdata/persons/$personId': typeof MasterdataPersonsPersonIdRouteWithChildren;
  '/patients/$patientId/anamnesis': typeof PatientsPatientIdAnamnesisRoute;
  '/patients/$patientId/diagnostics': typeof PatientsPatientIdDiagnosticsRoute;
  '/patients/$patientId/document': typeof PatientsPatientIdDocumentRoute;
  '/patients/$patientId/history': typeof PatientsPatientIdHistoryRoute;
  '/patients/$patientId/network': typeof PatientsPatientIdNetworkRoute;
  '/patients/$patientId/therapy': typeof PatientsPatientIdTherapyRoute;
  '/screening/$screeningId/individuals': typeof ScreeningScreeningIdIndividualsRouteWithChildren;
  '/appointments/$appointmentId': typeof AppointmentsAppointmentIdIndexRoute;
  '/contact-tracing/$patientId/': typeof ContactTracingPatientIdIndexRoute;
  '/patients/$patientId/': typeof PatientsPatientIdIndexRoute;
  '/review/$fileId': typeof ReviewFileIdIndexRoute;
  '/screening/$screeningId/': typeof ScreeningScreeningIdIndexRoute;
  '/masterdata/persons/$personId/document': typeof MasterdataPersonsPersonIdDocumentRoute;
  '/masterdata/persons/$personId/history': typeof MasterdataPersonsPersonIdHistoryRoute;
  '/screening/$screeningId/individuals/$individualId': typeof ScreeningScreeningIdIndividualsIndividualIdRouteWithChildren;
  '/masterdata/persons/$personId/': typeof MasterdataPersonsPersonIdIndexRoute;
  '/screening/$screeningId/individuals/': typeof ScreeningScreeningIdIndividualsIndexRoute;
  '/screening/$screeningId/individuals/$individualId/document': typeof ScreeningScreeningIdIndividualsIndividualIdDocumentRoute;
  '/screening/$screeningId/individuals/$individualId/': typeof ScreeningScreeningIdIndividualsIndividualIdIndexRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/appointments': typeof AppointmentsIndexRoute;
  '/contact-tracing': typeof ContactTracingIndexRoute;
  '/history': typeof HistoryIndexRoute;
  '/masterdata': typeof MasterdataIndexRoute;
  '/patients': typeof PatientsIndexRoute;
  '/screening': typeof ScreeningIndexRoute;
  '/todos': typeof TodosIndexRoute;
  '/contact-tracing/$patientId/document': typeof ContactTracingPatientIdDocumentRoute;
  '/patients/$patientId/anamnesis': typeof PatientsPatientIdAnamnesisRoute;
  '/patients/$patientId/diagnostics': typeof PatientsPatientIdDiagnosticsRoute;
  '/patients/$patientId/document': typeof PatientsPatientIdDocumentRoute;
  '/patients/$patientId/history': typeof PatientsPatientIdHistoryRoute;
  '/patients/$patientId/network': typeof PatientsPatientIdNetworkRoute;
  '/patients/$patientId/therapy': typeof PatientsPatientIdTherapyRoute;
  '/appointments/$appointmentId': typeof AppointmentsAppointmentIdIndexRoute;
  '/contact-tracing/$patientId': typeof ContactTracingPatientIdIndexRoute;
  '/patients/$patientId': typeof PatientsPatientIdIndexRoute;
  '/review/$fileId': typeof ReviewFileIdIndexRoute;
  '/screening/$screeningId': typeof ScreeningScreeningIdIndexRoute;
  '/masterdata/persons/$personId/document': typeof MasterdataPersonsPersonIdDocumentRoute;
  '/masterdata/persons/$personId/history': typeof MasterdataPersonsPersonIdHistoryRoute;
  '/masterdata/persons/$personId': typeof MasterdataPersonsPersonIdIndexRoute;
  '/screening/$screeningId/individuals': typeof ScreeningScreeningIdIndividualsIndexRoute;
  '/screening/$screeningId/individuals/$individualId/document': typeof ScreeningScreeningIdIndividualsIndividualIdDocumentRoute;
  '/screening/$screeningId/individuals/$individualId': typeof ScreeningScreeningIdIndividualsIndividualIdIndexRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/': typeof IndexRoute;
  '/appointments': typeof AppointmentsRouteWithChildren;
  '/patients': typeof PatientsRouteWithChildren;
  '/screening': typeof ScreeningRouteWithChildren;
  '/contact-tracing/$patientId': typeof ContactTracingPatientIdRouteWithChildren;
  '/patients/$patientId': typeof PatientsPatientIdRouteWithChildren;
  '/screening/$screeningId': typeof ScreeningScreeningIdRouteWithChildren;
  '/appointments/': typeof AppointmentsIndexRoute;
  '/contact-tracing/': typeof ContactTracingIndexRoute;
  '/history/': typeof HistoryIndexRoute;
  '/masterdata/': typeof MasterdataIndexRoute;
  '/patients/': typeof PatientsIndexRoute;
  '/screening/': typeof ScreeningIndexRoute;
  '/todos/': typeof TodosIndexRoute;
  '/contact-tracing/$patientId/document': typeof ContactTracingPatientIdDocumentRoute;
  '/masterdata/persons/$personId': typeof MasterdataPersonsPersonIdRouteWithChildren;
  '/patients/$patientId/anamnesis': typeof PatientsPatientIdAnamnesisRoute;
  '/patients/$patientId/diagnostics': typeof PatientsPatientIdDiagnosticsRoute;
  '/patients/$patientId/document': typeof PatientsPatientIdDocumentRoute;
  '/patients/$patientId/history': typeof PatientsPatientIdHistoryRoute;
  '/patients/$patientId/network': typeof PatientsPatientIdNetworkRoute;
  '/patients/$patientId/therapy': typeof PatientsPatientIdTherapyRoute;
  '/screening/$screeningId/individuals': typeof ScreeningScreeningIdIndividualsRouteWithChildren;
  '/appointments/$appointmentId/': typeof AppointmentsAppointmentIdIndexRoute;
  '/contact-tracing/$patientId/': typeof ContactTracingPatientIdIndexRoute;
  '/patients/$patientId/': typeof PatientsPatientIdIndexRoute;
  '/review/$fileId/': typeof ReviewFileIdIndexRoute;
  '/screening/$screeningId/': typeof ScreeningScreeningIdIndexRoute;
  '/masterdata/persons/$personId/document': typeof MasterdataPersonsPersonIdDocumentRoute;
  '/masterdata/persons/$personId/history': typeof MasterdataPersonsPersonIdHistoryRoute;
  '/screening/$screeningId/individuals/$individualId': typeof ScreeningScreeningIdIndividualsIndividualIdRouteWithChildren;
  '/masterdata/persons/$personId/': typeof MasterdataPersonsPersonIdIndexRoute;
  '/screening/$screeningId/individuals/': typeof ScreeningScreeningIdIndividualsIndexRoute;
  '/screening/$screeningId/individuals/$individualId/document': typeof ScreeningScreeningIdIndividualsIndividualIdDocumentRoute;
  '/screening/$screeningId/individuals/$individualId/': typeof ScreeningScreeningIdIndividualsIndividualIdIndexRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/appointments'
    | '/patients'
    | '/screening'
    | '/contact-tracing/$patientId'
    | '/patients/$patientId'
    | '/screening/$screeningId'
    | '/appointments/'
    | '/contact-tracing'
    | '/history'
    | '/masterdata'
    | '/patients/'
    | '/screening/'
    | '/todos'
    | '/contact-tracing/$patientId/document'
    | '/masterdata/persons/$personId'
    | '/patients/$patientId/anamnesis'
    | '/patients/$patientId/diagnostics'
    | '/patients/$patientId/document'
    | '/patients/$patientId/history'
    | '/patients/$patientId/network'
    | '/patients/$patientId/therapy'
    | '/screening/$screeningId/individuals'
    | '/appointments/$appointmentId'
    | '/contact-tracing/$patientId/'
    | '/patients/$patientId/'
    | '/review/$fileId'
    | '/screening/$screeningId/'
    | '/masterdata/persons/$personId/document'
    | '/masterdata/persons/$personId/history'
    | '/screening/$screeningId/individuals/$individualId'
    | '/masterdata/persons/$personId/'
    | '/screening/$screeningId/individuals/'
    | '/screening/$screeningId/individuals/$individualId/document'
    | '/screening/$screeningId/individuals/$individualId/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/appointments'
    | '/contact-tracing'
    | '/history'
    | '/masterdata'
    | '/patients'
    | '/screening'
    | '/todos'
    | '/contact-tracing/$patientId/document'
    | '/patients/$patientId/anamnesis'
    | '/patients/$patientId/diagnostics'
    | '/patients/$patientId/document'
    | '/patients/$patientId/history'
    | '/patients/$patientId/network'
    | '/patients/$patientId/therapy'
    | '/appointments/$appointmentId'
    | '/contact-tracing/$patientId'
    | '/patients/$patientId'
    | '/review/$fileId'
    | '/screening/$screeningId'
    | '/masterdata/persons/$personId/document'
    | '/masterdata/persons/$personId/history'
    | '/masterdata/persons/$personId'
    | '/screening/$screeningId/individuals'
    | '/screening/$screeningId/individuals/$individualId/document'
    | '/screening/$screeningId/individuals/$individualId';
  id:
    | '__root__'
    | '/'
    | '/appointments'
    | '/patients'
    | '/screening'
    | '/contact-tracing/$patientId'
    | '/patients/$patientId'
    | '/screening/$screeningId'
    | '/appointments/'
    | '/contact-tracing/'
    | '/history/'
    | '/masterdata/'
    | '/patients/'
    | '/screening/'
    | '/todos/'
    | '/contact-tracing/$patientId/document'
    | '/masterdata/persons/$personId'
    | '/patients/$patientId/anamnesis'
    | '/patients/$patientId/diagnostics'
    | '/patients/$patientId/document'
    | '/patients/$patientId/history'
    | '/patients/$patientId/network'
    | '/patients/$patientId/therapy'
    | '/screening/$screeningId/individuals'
    | '/appointments/$appointmentId/'
    | '/contact-tracing/$patientId/'
    | '/patients/$patientId/'
    | '/review/$fileId/'
    | '/screening/$screeningId/'
    | '/masterdata/persons/$personId/document'
    | '/masterdata/persons/$personId/history'
    | '/screening/$screeningId/individuals/$individualId'
    | '/masterdata/persons/$personId/'
    | '/screening/$screeningId/individuals/'
    | '/screening/$screeningId/individuals/$individualId/document'
    | '/screening/$screeningId/individuals/$individualId/';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AppointmentsRoute: typeof AppointmentsRouteWithChildren;
  PatientsRoute: typeof PatientsRouteWithChildren;
  ScreeningRoute: typeof ScreeningRouteWithChildren;
  ContactTracingPatientIdRoute: typeof ContactTracingPatientIdRouteWithChildren;
  ContactTracingIndexRoute: typeof ContactTracingIndexRoute;
  HistoryIndexRoute: typeof HistoryIndexRoute;
  MasterdataIndexRoute: typeof MasterdataIndexRoute;
  TodosIndexRoute: typeof TodosIndexRoute;
  MasterdataPersonsPersonIdRoute: typeof MasterdataPersonsPersonIdRouteWithChildren;
  ReviewFileIdIndexRoute: typeof ReviewFileIdIndexRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppointmentsRoute: AppointmentsRouteWithChildren,
  PatientsRoute: PatientsRouteWithChildren,
  ScreeningRoute: ScreeningRouteWithChildren,
  ContactTracingPatientIdRoute: ContactTracingPatientIdRouteWithChildren,
  ContactTracingIndexRoute: ContactTracingIndexRoute,
  HistoryIndexRoute: HistoryIndexRoute,
  MasterdataIndexRoute: MasterdataIndexRoute,
  TodosIndexRoute: TodosIndexRoute,
  MasterdataPersonsPersonIdRoute: MasterdataPersonsPersonIdRouteWithChildren,
  ReviewFileIdIndexRoute: ReviewFileIdIndexRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/appointments",
        "/patients",
        "/screening",
        "/contact-tracing/$patientId",
        "/contact-tracing/",
        "/history/",
        "/masterdata/",
        "/todos/",
        "/masterdata/persons/$personId",
        "/review/$fileId/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/appointments": {
      "filePath": "appointments.tsx",
      "children": [
        "/appointments/",
        "/appointments/$appointmentId/"
      ]
    },
    "/patients": {
      "filePath": "patients.tsx",
      "children": [
        "/patients/$patientId",
        "/patients/"
      ]
    },
    "/screening": {
      "filePath": "screening.tsx",
      "children": [
        "/screening/$screeningId",
        "/screening/"
      ]
    },
    "/contact-tracing/$patientId": {
      "filePath": "contact-tracing/$patientId.tsx",
      "children": [
        "/contact-tracing/$patientId/document",
        "/contact-tracing/$patientId/"
      ]
    },
    "/patients/$patientId": {
      "filePath": "patients/$patientId.tsx",
      "parent": "/patients",
      "children": [
        "/patients/$patientId/anamnesis",
        "/patients/$patientId/diagnostics",
        "/patients/$patientId/document",
        "/patients/$patientId/history",
        "/patients/$patientId/network",
        "/patients/$patientId/therapy",
        "/patients/$patientId/"
      ]
    },
    "/screening/$screeningId": {
      "filePath": "screening/$screeningId.tsx",
      "parent": "/screening",
      "children": [
        "/screening/$screeningId/individuals",
        "/screening/$screeningId/"
      ]
    },
    "/appointments/": {
      "filePath": "appointments/index.tsx",
      "parent": "/appointments"
    },
    "/contact-tracing/": {
      "filePath": "contact-tracing/index.tsx"
    },
    "/history/": {
      "filePath": "history/index.tsx"
    },
    "/masterdata/": {
      "filePath": "masterdata/index.tsx"
    },
    "/patients/": {
      "filePath": "patients/index.tsx",
      "parent": "/patients"
    },
    "/screening/": {
      "filePath": "screening/index.tsx",
      "parent": "/screening"
    },
    "/todos/": {
      "filePath": "todos/index.tsx"
    },
    "/contact-tracing/$patientId/document": {
      "filePath": "contact-tracing/$patientId/document.tsx",
      "parent": "/contact-tracing/$patientId"
    },
    "/masterdata/persons/$personId": {
      "filePath": "masterdata/persons/$personId.tsx",
      "children": [
        "/masterdata/persons/$personId/document",
        "/masterdata/persons/$personId/history",
        "/masterdata/persons/$personId/"
      ]
    },
    "/patients/$patientId/anamnesis": {
      "filePath": "patients/$patientId/anamnesis.tsx",
      "parent": "/patients/$patientId"
    },
    "/patients/$patientId/diagnostics": {
      "filePath": "patients/$patientId/diagnostics.tsx",
      "parent": "/patients/$patientId"
    },
    "/patients/$patientId/document": {
      "filePath": "patients/$patientId/document.tsx",
      "parent": "/patients/$patientId"
    },
    "/patients/$patientId/history": {
      "filePath": "patients/$patientId/history.tsx",
      "parent": "/patients/$patientId"
    },
    "/patients/$patientId/network": {
      "filePath": "patients/$patientId/network.tsx",
      "parent": "/patients/$patientId"
    },
    "/patients/$patientId/therapy": {
      "filePath": "patients/$patientId/therapy.tsx",
      "parent": "/patients/$patientId"
    },
    "/screening/$screeningId/individuals": {
      "filePath": "screening/$screeningId/individuals.tsx",
      "parent": "/screening/$screeningId",
      "children": [
        "/screening/$screeningId/individuals/$individualId",
        "/screening/$screeningId/individuals/"
      ]
    },
    "/appointments/$appointmentId/": {
      "filePath": "appointments/$appointmentId/index.tsx",
      "parent": "/appointments"
    },
    "/contact-tracing/$patientId/": {
      "filePath": "contact-tracing/$patientId/index.tsx",
      "parent": "/contact-tracing/$patientId"
    },
    "/patients/$patientId/": {
      "filePath": "patients/$patientId/index.tsx",
      "parent": "/patients/$patientId"
    },
    "/review/$fileId/": {
      "filePath": "review/$fileId/index.tsx"
    },
    "/screening/$screeningId/": {
      "filePath": "screening/$screeningId/index.tsx",
      "parent": "/screening/$screeningId"
    },
    "/masterdata/persons/$personId/document": {
      "filePath": "masterdata/persons/$personId/document.tsx",
      "parent": "/masterdata/persons/$personId"
    },
    "/masterdata/persons/$personId/history": {
      "filePath": "masterdata/persons/$personId/history.tsx",
      "parent": "/masterdata/persons/$personId"
    },
    "/screening/$screeningId/individuals/$individualId": {
      "filePath": "screening/$screeningId/individuals/$individualId.tsx",
      "parent": "/screening/$screeningId/individuals",
      "children": [
        "/screening/$screeningId/individuals/$individualId/document",
        "/screening/$screeningId/individuals/$individualId/"
      ]
    },
    "/masterdata/persons/$personId/": {
      "filePath": "masterdata/persons/$personId/index.tsx",
      "parent": "/masterdata/persons/$personId"
    },
    "/screening/$screeningId/individuals/": {
      "filePath": "screening/$screeningId/individuals/index.tsx",
      "parent": "/screening/$screeningId/individuals"
    },
    "/screening/$screeningId/individuals/$individualId/document": {
      "filePath": "screening/$screeningId/individuals/$individualId/document.tsx",
      "parent": "/screening/$screeningId/individuals/$individualId"
    },
    "/screening/$screeningId/individuals/$individualId/": {
      "filePath": "screening/$screeningId/individuals/$individualId/index.tsx",
      "parent": "/screening/$screeningId/individuals/$individualId"
    }
  }
}
ROUTE_MANIFEST_END */
